import { LocationDTO } from "src/app/features/map-features/sections/locations-section/models/LocationDTO";
import { VirtualLocationDTO } from "src/app/features/map-features/ui/organisms/route-sheet/models/VirtualLocationDTO";

export function CreateEmptyLocationDTO() : LocationDTO {
    return {
        id: 0,
        guid: '',
        cordsX: '',
        cordsY: '',
        identifier: '',
        description: '',
        color: '',
        data: [],
        counts: 0,
        icon: '',
        panelIcon: '',
        locationCategory: '',
        idLocationCategory: 0,
        group: {
          id: 0,
          name: '',
        },
        subGroup: {
          id: 0,
          name: '',
        },
        alias: '',
        isFullyAvailable: false,
        lastVoltaje: '',
        gpsStatus: '',
        canLock: '',
        lastUpdate: '',
        batteryPercent: '',
        activeType: '',
        statusVehiculo: '',
        categoryStatus: '',
        idLocationCategoryStatus: 0,
        statusFlags: [],
        flagTypes: [],
    };
}

export function CreateEmptyVirtualLocationDTO() : VirtualLocationDTO {
    return {
        id: 0,
        guid: '',
        cordsX: '',
        cordsY: '',
        identifier: '',
        description: '',
        data: [],
        icon: '',
        locationCategory: '',
        idLocationCategory: 0,
        group: {
          id: 0,
          name: '',
        },
        subGroup: {
          id: 0,
          name: '',
        },
        clientId: '',
        cords: null,
        idGroup: 0,
        idSubGroup: 0,
        activeIcon: '',
        status: 0,
        createdIn: '',
        createdBy: '',
        idLocationCategoryStatus: 0
    };
}